import { BarChartConfig } from '../data/BarChartConfig';
import { ChartDataArray } from '../data/ChartDataArray';
import { ChartDataComparisonType } from '../data/ChartDataComparisonType';
import { ChartDataType } from '../data/ChartDataType';
import { LineChartConfig } from '../data/LineChartConfig';

export class RendererConfig {
  private primaryData?: ChartDataArray;

  private comparisonData?: ChartDataArray;

  private secondaryData?: ChartDataArray;

  private secondaryComparisonData?: ChartDataArray;

  private breakdownData?: ChartDataArray[];

  private primaryPlanData?: ChartDataArray;

  private secondaryPlanData?: ChartDataArray;
  private averageData?: ChartDataArray;

  constructor(private config: LineChartConfig | BarChartConfig) {
    this.primaryData = this.config.getDataArray(ChartDataType.primary);
    this.comparisonData = this.config.getDataArray(ChartDataType.primary, ChartDataComparisonType.comparison);
    this.secondaryData = this.config.getDataArray(ChartDataType.secondary);
    this.secondaryComparisonData = this.config.getDataArray(
      ChartDataType.secondary,
      ChartDataComparisonType.comparison
    );
    this.breakdownData = this.config.getDataArrays(ChartDataType.breakdown);
    this.primaryPlanData = this.config.getDataArray(ChartDataType.primary, ChartDataComparisonType.plan);
    this.secondaryPlanData = this.config.getDataArray(ChartDataType.secondary, ChartDataComparisonType.plan);
    this.averageData = this.config.getDataArray(ChartDataType.average);
  }

  public hasComparisonData(): boolean {
    return !!this.comparisonData || !!this.secondaryComparisonData;
  }

  public hasSecondaryData(): boolean {
    return !!this.secondaryData;
  }

  public hasBreakdownData(): boolean {
    return !!this.breakdownData && this.breakdownData.length !== 0;
  }

  public hasPlanData(): boolean {
    return !!this.primaryPlanData;
  }

  public hasSecondaryAxis(): boolean {
    return !!this.config.additionalAxis;
  }

  public hasAverageData(): boolean {
    return !!this.averageData;
  }

  public getPrimaryData(): ChartDataArray | undefined {
    return this.primaryData;
  }

  public getComparisonData(): ChartDataArray | undefined {
    return this.comparisonData;
  }

  public getSecondaryData(): ChartDataArray | undefined {
    return this.secondaryData;
  }

  public getSecondaryComparisonData(): ChartDataArray | undefined {
    return this.secondaryComparisonData;
  }

  public getBreakdownData(): ChartDataArray[] | undefined {
    return this.breakdownData;
  }

  public getPrimaryPlanData(): ChartDataArray | undefined {
    return this.primaryPlanData;
  }

  public getSecondaryPlanData(): ChartDataArray | undefined {
    return this.secondaryPlanData;
  }

  public getAverageData(): ChartDataArray | undefined {
    return this.averageData;
  }
}
